import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import throttle from 'lodash.throttle';
import { t } from 'ttag';
import loadTranslations from 'js/localeSetup';
import ItemCounter from '../cart/comps/counter';
import HeaderSearch from '../headerSearch/headerSearch';
import ErrorBoundary from '../ErrorBoundary';
import './styles/styles.less';
import './styles/newHeader.less';
import ProfileLoggedIn from '../reusable-components/icons/header/ProfileLoggedIn';
import ProfileLoggedOut from '../reusable-components/icons/header/ProfileLoggedOut';
import Favorite from '../sharedSvgs/favorite.svg';

const MobileMenu = React.lazy(() => import('../mobileMenu/mobileMenu'));
const TopMenu = React.lazy(() => import('../TopMenu/TopMenu'));

const overlay = document.getElementById('header-click-overlay');
const headerDOM = document.getElementById('header');
const bodyOriginalClasses = window.is_it_black_week
  ? `${document.body.className} black_friday`
  : document.body.className;

const cartIcon =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjIgMjIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDIyIDIyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0ZGRkZGRjt9PC9zdHlsZT48cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTguNiwxNC43YzAuMiwwLDAuNC0wLjEsMC41LTAuMWMwLjEtMC4xLDAuMS0wLjIsMC4yLTAuNGMwLjYtMi4yLDEuMy00LjUsMS45LTYuN2MwLjEtMC4zLDAtMC41LTAuMS0wLjdjLTAuMS0wLjItMC4zLTAuMy0wLjYtMC4zSDUuOEM1LjQsNS4yLDUsMy44LDQuNiwyLjVDNC41LDIuNCw0LjUsMi4yLDQuNCwyLjJDNC4yLDIuMSw0LjEsMiwzLjksMkgwLjhjLTEsMC0xLDEuNCwwLDEuNGgyLjZjMS4yLDQuNCwyLjUsOC44LDMuNywxMy4yYy0wLjgsMC40LTEuNCwxLjEtMS40LDJDNS42LDE5LjksNi43LDIxLDgsMjFzMi40LTEsMi40LTIuM2MwLTAuMy0wLjEtMC41LTAuMS0wLjhoNC43Yy0wLjEsMC4yLTAuMSwwLjUtMC4xLDAuOGMwLDEuMiwxLjEsMi4zLDIuMywyLjNjMS4zLDAsMi40LTEsMi40LTIuM2MwLTEuMi0xLTIuMi0yLjMtMi4zaC0wLjFIOC42Yy0wLjEtMC42LTAuMy0xLjItMC41LTEuOEwxOC42LDE0LjdMMTguNiwxNC43eiBNMTAuNiw4YzAuNSwxLjgsMC45LDMuNSwxLjQsNS4yaC0xLjRDMTAuMiwxMS41LDkuNyw5LjcsOS4yLDhIMTAuNkwxMC42LDh6IE0xMy40LDhjMC41LDEuOCwwLjksMy41LDEuNCw1LjJoLTEuNGMtMC40LTEuOC0wLjktMy41LTEuNC01LjJDMTIuMSw4LDEzLjQsOCwxMy40LDh6IE0xNi40LDhjMC41LDEuOCwxLDMuNSwxLjQsNS4yaC0xLjRDMTYsMTEuNSwxNS41LDkuNywxNSw4SDE2LjR6IE0xOC43LDEwLjdjLTAuMi0wLjktMC41LTEuOC0wLjgtMi43aDEuNUMxOS4yLDguOSwxOSw5LjgsMTguNywxMC43eiBNNy42LDhjMC41LDEuOCwwLjksMy41LDEuNCw1LjJINy43Yy0wLjUtMS44LTEtMy41LTEuNS01LjJDNi4yLDgsNy42LDgsNy42LDh6IE04LDE5LjZjLTAuNSwwLTAuOC0wLjQtMC44LTAuOGMwLTAuNSwwLjQtMC44LDAuOC0wLjhjMC41LDAsMC44LDAuNCwwLjgsMC44QzguOCwxOS4yLDguNCwxOS42LDgsMTkuNkw4LDE5LjZ6IE0xNy4xLDE5LjZjLTAuNSwwLTAuOC0wLjQtMC44LTAuOGMwLTAuNSwwLjQtMC44LDAuOC0wLjhjMC41LDAsMC44LDAuNCwwLjgsMC44QzE3LjgsMTkuMiwxNy41LDE5LjYsMTcuMSwxOS42TDE3LjEsMTkuNnoiLz48L3N2Zz4=';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLoggedIn: props.logged_in,
      pageIsCached: props.page_is_cached,
      customer_accounts_enabled: props.customer_accounts_enabled,
      menuAPIURL: headerDOM.getAttribute('data-menuapiurl'),
      menuAPIURLTop: headerDOM.getAttribute('data-menu-api-url-top'),
      menuAPIURLService: headerDOM.getAttribute('data-menu-api-url-service'),
      urlLoggedInStatus: '/v1.1/status/',
      placeholder: headerDOM.getAttribute('data-placeholder'),
      category: headerDOM.getAttribute('data-category'),
      products: headerDOM.getAttribute('data-products'),
      go: headerDOM.getAttribute('data-go'),
      showAll: headerDOM.getAttribute('data-txt-Show-All'),
      activeMenuItem: null,
      verticalOffset: 0,
      // progress: 'wrapper fade notLoaded',
      width: window.innerWidth,
      flag: headerDOM.getAttribute('data-flag') === 'True',
      display: '',
      bool_favorite: true
    };
    this.handleOverLay = this.handleOverLay.bind(this);
    this.updateDimensions = throttle(this.updateDimensions.bind(this), 250);
  }

  componentDidMount() {
    this.updateDimensions();
    if (this.state.customer_accounts_enabled && this.state.pageIsCached) {
      this.checkIsUserLoggedIn();
    }
    overlay.addEventListener('click', this.overlayHandler);
    window.addEventListener('resize', this.updateDimensions);
    // this.setState({ progress: 'wrapper fade fading' }, () => {
    //   setTimeout(() => {
    //     this.setState({ progress: 'wrapper fade' });
    //   }, 250);
    // });
  }

  componentWillUnmount() {
    overlay.removeEventListener('click', this.overlayHandler);
    window.removeEventListener('resize', this.updateDimensions);
  }

  handleOverLay = (menuItem, showOverlay, itemId) => {
    this.setState({ activeMenuItem: menuItem }, () => {
      overlay.style.display = showOverlay ? 'block' : 'none';
      if (!showOverlay) {
        document.body.className = document.body.className.replace(
          'bodyLocked',
          ''
        );
      }
    });

    if (itemId !== undefined) {
      window.ua(
        'trackStructEvent',
        'navigation',
        showOverlay ? 'show-overlay' : 'hide-overlay',
        String(itemId)
      );
    }
  };

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  overlayHandler = () => {
    this.setState({
      activeMenuItem: null
    });
    document.body.className = bodyOriginalClasses;
    overlay.style.display = 'none';
  };

  checkIsUserLoggedIn = () => {
    axios
      .head(this.state.urlLoggedInStatus)
      .then(response => {
        // eslint-disable-next-line
        const bool = response.headers['x-authorized'].toLowerCase() === 'true';
        this.setState({
          isUserLoggedIn: bool
        });
      })
      .catch(() => {});
  };

  toggleMobileMenu = () => {
    if (document.body.className.indexOf('bodyLocked') < 0) {
      window.shouldHideHeaderOnScroll = false;
      if (document.querySelector('.zopim') != null) {
        document.querySelector('.zopim').className +=
          document.querySelector('.zopim').className.indexOf('hidden') < 0
            ? ' hidden'
            : '';
      }

      this.setState({ verticalOffset: window.pageYOffset }, () => {
        document.body.className += ' bodyLocked';
        window.shouldHideHeaderOnScroll = false;
      });

      window.ua('trackStructEvent', 'navigation', 'show-overlay', 'null');
    } else {
      window.shouldHideHeaderOnScroll = true;
      if (document.querySelector('.zopim') != null) {
        document.querySelector('.zopim').className = 'zopim';
      }
      document.body.className = bodyOriginalClasses;
      // eslint-disable-next-line no-multi-assign
      document.documentElement.scrollTop = document.body.scrollTop =
        this.state.verticalOffset;

      window.ua('trackStructEvent', 'navigation', 'hide-overlay', 'null');
    }
  };

  returnProfileIcon = bool => {
    if (bool) return <ProfileLoggedIn />;
    return <ProfileLoggedOut />;
  };

  renderFavoriteIcon = () => {
    if (window && window.config.loginStatus) {
      return (
        <a
          aria-label={t`View your favourited products`}
          href={
            window?.config?.feature_oauth2
              ? '/account/home/#/favorite/'
              : '/unisportfc/#/favorite/'
          }
          className="favorite-btn menu-btn"
          name="favorite summary"
        >
          <img src={Favorite} alt="favorite" />
        </a>
      );
    }
    return null;
  };

  getProfileUrl = () => {
    if (window.config.feature_oauth2) {
      return '/account/home/#/profile/';
    }
    return '/unisportfc/#/profile/';
  };

  getLoginUrl = () => {
    if (window.config.feature_oauth2) {
      return '/account/login/';
    }
    return '/unisportfc/#/login/';
  };

  returnActions = () => (
    <div className="actions" data-testid="actions">
      {this.state.customer_accounts_enabled && (
        <a
          aria-label={
            this.state.isUserLoggedIn
              ? t`Go to your Unisport profile`
              : t`Log in to your Unisport profile`
          }
          href={
            this.state.isUserLoggedIn
              ? this.getProfileUrl()
              : this.getLoginUrl()
          }
          id="profile_icon"
          className="profile-btn menu-btn"
          tabIndex="0"
        >
          {this.returnProfileIcon(this.state.isUserLoggedIn)}
        </a>
      )}

      {this.state.bool_favorite && this.renderFavoriteIcon()}

      <a
        aria-label={t`Go to your cart`}
        href="/cart/summary/"
        className="basket-btn menu-btn"
        name="cart summary"
      >
        <img src={cartIcon} alt="cart" />
        <ErrorBoundary errorComponent={null} location="header">
          <ItemCounter />
        </ErrorBoundary>
      </a>
      <React.Suspense fallback={<div id="menuPlaceholder" />}>
        <div className="v-divider" />
        <MobileMenu
          url={this.state.menuAPIURLTop}
          menuAPIURLService={this.state.menuAPIURLService}
          showAll={this.state.showAll}
          toggleMobileMenu={this.toggleMobileMenu}
          handleOverLay={this.handleOverLay}
          isMenuItemActive={
            this.state.activeMenuItem === 'TopMenu' ||
            this.state.activeMenuItem === 'HeaderSearch'
          }
        />
      </React.Suspense>
    </div>
  );

  returnHeaderSearch = () => (
    <ErrorBoundary errorComponent={null} location="header">
      <HeaderSearch
        isItemActive={this.state.activeMenuItem === 'HeaderSearch'}
        placeholder={this.state.placeholder}
        category={this.state.category}
        products={this.state.products}
        go={this.state.go}
        handleOverLay={this.handleOverLay}
        flag={this.state.flag}
      />
    </ErrorBoundary>
  );

  returnNewHeader = display => {
    return (
      <div id="newHeader" className={`${display}`}>
        <div className="row1">
          <div className="logo" data-testid="logo">
            <a
              aria-label={t`Go to the Unisport Frontpage`}
              href="/"
              className="logo-btn h-10"
              tabIndex="0"
              style={{ fontSize: 0 }}
            >
              Logo
            </a>
          </div>
          {this.returnActions()}
        </div>
        <div className="row2">{this.returnHeaderSearch()}</div>
      </div>
    );
  };

  returnNewHeaderDesktop = display => {
    return (
      <div id="newHeader" className={`desktop ${display}`}>
        <div className="row1">
          <div className="logo" data-testid="logo">
            <a
              aria-label={t`Go to the Unisport frontpage`}
              href="/"
              className="logo-btn"
              tabIndex="0"
              style={{ fontSize: 0 }}
            >
              Logo
            </a>
          </div>
          <div className="search-wrapper-desktop">
            {this.returnHeaderSearch()}
          </div>
          {this.returnActions()}
        </div>
        <div className="row2">
          <ErrorBoundary errorComponent={null} location="header">
            <React.Suspense
              fallback={
                <div
                  style={{
                    width: this.state.width >= 1350 ? '780px' : '580px',
                    height: '50px',
                    float: 'left'
                  }}
                />
              }
            >
              <TopMenu
                isItemActive={this.state.activeMenuItem === 'TopMenu'}
                handleOverLay={this.handleOverLay}
                menuAPIURL={this.state.menuAPIURL}
              />
            </React.Suspense>
          </ErrorBoundary>
        </div>
      </div>
    );
  };

  render() {
    if (window.innerWidth < 1024)
      return this.returnNewHeader(this.state.display);
    return this.returnNewHeaderDesktop(this.state.display);
  }
}

window.HeaderState = {};
const { HeaderState } = window;

HeaderState.searchActive = false;
HeaderState.burgerMenuActive = false;
HeaderState.TopMenuActive = false;
HeaderState.hide = () => {
  HeaderState.searchActive = false;
  HeaderState.burgerMenuActive = false;
  HeaderState.TopMenuActive = false;
  HeaderState.index = 0;
};

HeaderState.hideOne = _item => {
  HeaderState[_item] = false;
};

HeaderState.show = _item => {
  HeaderState[_item] = true;
};

(async () => {
  const rootElement = document.getElementById('header');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(
      <Header
        logged_in={window.headerData.logged_in}
        page_is_cached={window.headerData.page_is_cached}
        customer_accounts_enabled={window.headerData.customer_accounts_enabled}
      />,
      rootElement
    );
  }
})();
